var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"viewer-container"},[_c('div',{staticClass:"return-btn",on:{"click":_vm.retrunFrom}},[_vm._v("返回")]),_c('iframe',{attrs:{"src":_vm.protocol + '//static-cdn.vcbeat.top/pdf/web/viewer-d8.html?file=' + _vm.$route.query.file,"width":"100%","height":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }